import { useEffect, forwardRef, useImperativeHandle } from 'react';
import { Button } from 'antd';
import { useCountdown, useRequest } from '@/hooks';
import { commonApi } from '@/api';
import { __APP_ENV } from '@/const/env';

import type { UseFormRes } from '@/components';
import { getAccessToken } from '@/utils';
import { useText, formatResend } from './customization';

export interface ICountdownRef {
  handleCountdown?: (isAccessible?: boolean) => Promise<void>,
  startCountdown?: () => void,
  restartTime?: () => void
}

export interface CountdownButtonProps {
  form: UseFormRes;
  arrival?: (boo?: boolean) => void
  otherParams: {
    country?: string;
    certificate?: string | null
  }
  onFrequently?: () => void;
  accessToken?: string | null;
  getRegisteredData?: (val: boolean) => void
  countdownCallback?: (res: Record<string, any>) => void;
  unPassed?: () => void,
  ref?: ICountdownRef,
  getCertificate?: (str: string | null) => void,
  onChangeType?: () => void,
  errorMessage?: (str: string) => void
}

const CountdownButton = forwardRef<ICountdownRef, CountdownButtonProps>(({
  form,
  otherParams,
  countdownCallback,
  arrival,
  unPassed,
  getCertificate,
  onChangeType,
  errorMessage,
}, ref) => {

  const { startCountdown, timeRemaining, isRunning, restartTime } = useCountdown(30);
  const text = useText();
  const _filterCode = 24034;
  const errorCode = 120021;
  const sendCode = useRequest({ url: commonApi.loginSendCode, method: 'post', isTips: [_filterCode, errorCode] });
  const riskVerification = useRequest({ url: commonApi.riskVerification, method: 'post' })

  /**
   * @param isAccessible 是否通行
   * @note 外部可允许通行，当外部不允许时进行发送验证码前的校验
   */
  const handleCountdown = async (isAccessible?: boolean) => {
    onChangeType?.()

    const { phone, captchaCode } = await form.validateFields(['phone', 'captchaCode']);
    const headers = { Accesstoken: getAccessToken() };

    if (phone) {
      try {
        const params: any = { ...otherParams, phone };
        if (captchaCode) {
          params.captchaCode = captchaCode;
        }

        let riskInfo = null
        if (!isAccessible) {
          riskInfo = await riskVerification.send({ ...otherParams, phone, sendModeType: 'SMS', certificate: undefined }, { headers })
        }

        let codeRes = null

        if (riskInfo?.data?.riskStatus || isAccessible) {
          codeRes = await sendCode.send(params, {
            headers
          }).then(res => {
            if (res.status?.code === _filterCode) unPassed?.()
            else if (res.status?.code === errorCode) {
              errorMessage?.(res.status?.msg)
            }
            else if (res.data) {
              startCountdown();
              return res
            }
          })
        }
        else {
          unPassed?.()
        }
        // @ts-ignore
        const callbackRes = countdownCallback?.(codeRes);
  
        if (callbackRes) {
          if (codeRes?.data?.code && __APP_ENV !== 'prod') {
            form.setFieldsValue({ code: codeRes?.data?.code });
          }
        }
        getCertificate?.(null)
      } catch (ex) {
        console.error(ex)
        getCertificate?.(null)
      }
    }
  }

  useEffect(() => {
    // if (timeRemaining <= 26) {
    //   arrival?.(true)
    // }
  }, [timeRemaining])

  useImperativeHandle(ref, () => ({
    handleCountdown,
    startCountdown,
    restartTime
  }), [otherParams.certificate, ref])

  return (
    <>
      <Button
        className='login_content_send_code'
        data-peblla-part="send-code-btn"
        style={{
          color: isRunning ? '#BABABA' : '#fff',
          // @ts-ignore
          backgroundColor: isRunning && '#E8E8E8',
          fontFamily: 'var(--fw6)'
        }}
        type='primary'
        disabled={isRunning}
        onClick={() => handleCountdown(true)}
        loading={sendCode.loading || riskVerification.loading}
      >
        {
          isRunning
            ? formatResend(text.resendTextTemplate, timeRemaining)
            : (text.sendCodeText ?? 'Send code')
        }
      </Button>
    </>
  )
})

export default CountdownButton;
